export const TRY_ON_MEETING_TYPES = ['VISIT', 'SECOND_VISIT', 'THIRD_VISIT'] as const;

export type TryOnMeetingType = (typeof TRY_ON_MEETING_TYPES)[number];

export type TryOnHeatLevel = 'none' | 'low' | 'medium' | 'high';

export type MeetingWithType = {
  type?: string;
  noShow?: boolean;
};

export function isTryOnMeetingType(type: string | undefined): type is TryOnMeetingType {
  return (TRY_ON_MEETING_TYPES as readonly string[]).includes(type ?? '');
}

export function countTryOnAppointments(meetings: MeetingWithType[] | undefined | null): number {
  if (!meetings?.length) {
    return 0;
  }

  return meetings.filter(
    (meeting) => isTryOnMeetingType(meeting.type) && !meeting.noShow,
  ).length;
}

export function getTryOnHeatLevel(count: number): TryOnHeatLevel {
  if (count <= 0) {
    return 'none';
  }
  if (count === 1) {
    return 'low';
  }
  if (count === 2) {
    return 'medium';
  }
  return 'high';
}

export type TryOnHeatPresentation = {
  textClass: string;
  iconClass: string;
  fillFlame: boolean;
  showFlame: boolean;
};

export function getTryOnHeatPresentation(level: TryOnHeatLevel): TryOnHeatPresentation {
  switch (level) {
    case 'low':
      return {
        textClass: 'text-[#c73e4d] font-semibold',
        iconClass: 'text-[#f54758]',
        fillFlame: false,
        showFlame: false,
      };
    case 'medium':
      return {
        textClass: 'text-[#c0650a] font-semibold',
        iconClass: 'text-[#e67e22]',
        fillFlame: true,
        showFlame: true,
      };
    case 'high':
      return {
        textClass: 'text-[#922b21] font-semibold',
        iconClass: 'text-[#c0392b]',
        fillFlame: true,
        showFlame: true,
      };
    default:
      return {
        textClass: 'text-gray-400',
        iconClass: 'text-gray-300',
        fillFlame: false,
        showFlame: false,
      };
  }
}

export type TryOnTypeCounts = Record<TryOnMeetingType, number>;

export function countTryOnAppointmentsByType(
  meetings: MeetingWithType[] | undefined | null,
): TryOnTypeCounts {
  const counts: TryOnTypeCounts = { VISIT: 0, SECOND_VISIT: 0, THIRD_VISIT: 0 };

  if (!meetings?.length) {
    return counts;
  }

  for (const meeting of meetings) {
    if (isTryOnMeetingType(meeting.type) && !meeting.noShow) {
      counts[meeting.type] += 1;
    }
  }

  return counts;
}
